<template>
  <div>
    <b-table striped hover :items="invoiceList" :fields="invoiceFields" @row-clicked="rowClickHandler">
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    userId: null,
    accountId: null
  },
  methods: {
    rowClickHandler (record, index) {
      this.$emit('clickOnInvoice', record.invoice_id)
    }
  },
  data () {
    return {
      invoiceFields: [
        { key: 'invoice_id', label: this.$i18n.t('Number invoices'), sortable: true, sortDirection: 'desc' },
        { key: 'date', label: this.$i18n.t('Date'), sortable: true, sortDirection: 'desc', formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) } },
        { key: 'binded_currency_sum', label: this.$i18n.t('Sum in currency'), sortable: true, formatter: (val, key, item) => { return Number(val).toFixed(2) } },
        { key: 'system_currency_sum', label: this.$i18n.t('Sum'), sortable: true, formatter: (val, key, item) => { return Number(val).toFixed(2) } }
      ]
    }
  },
  mounted () {
    let payload = {
      user_id: this.userId,
      account_id: this.accountId
    }
    this.$store.dispatch('Reports/GET_INVOICES', payload)
  },
  computed: {
    invoiceList () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Reports/INVOICES']))
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/reports/Invoices.vue